<span
    class="dot"
    [ngClass]="{
        red: severity === 'alarm',
        green: severity === 'success',
        orange: severity === 'warning',
        primary: severity === 'info',
    }"
></span>
